/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from 'react';
import * as Auth from "../../Login/Auth"


function Header() {
    const [userInfo] = useState(Auth.getUserInfo());

    useEffect(() => {
        //console.log(userInfo)
    })

    return (
        <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: "0" }}>
            <div className="navbar-header" style={{ width: "40%" }}>
                <div className="row">
                    <div className="col-sm-3">
                        <a className="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#A"><i className="fa fa-bars"></i> </a>
                    </div>
                    <div className="col-sm-8 m-t-sm">
                        <h3 className="text-success m-t-sm" >{userInfo.companyName}</h3>
                    </div>
                </div>

            </div>
            <ul className="nav navbar-top-links navbar-right">
                {/**
                <li>
                    <span className="m-r-sm text-muted welcome-message">INSPINIA</span>
                </li>
                 */}
                <li>
                    <a href="/logout">
                        <i className="fa fa-sign-out"></i> Log out
                  </a>
                </li>
            </ul>

        </nav>
    )
}

export { Header }